<template>
</template>
<style scoped>
@import "../assets/css/snow.css";
</style>
<script>
  export default {
    name: 'Christmas_theme_css',
    data: () => {
      return {}
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/ChristmasThemeCSS.vue